// Small reusable debounce utility
// Usage:
// const debounced = debounce(fn, wait);
// debounced(...) will schedule fn to run after wait ms
// debounced.cancel() will cancel any pending call
export default function debounce(fn, wait) {
    let timeoutId = null;

    function debounced(...args) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            timeoutId = null;
            fn.apply(this, args);
        }, wait);
    }

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };

    return debounced;
}
